import React, { useEffect, useState } from "react";
import { ArticleCategoriesViewModel } from "./ArticleCategoriesViewModel.csharp";
import classNames from "classnames";
import { ArticleCategoryGroupViewModel } from "./ArticleCategoryGroupViewModel.csharp";

export const ArticleCategories: React.FC<ArticleCategoriesViewModel> = ({
  heading,
  categoryGroups,
}) => {
  const [
    currentGroup,
    setCurrentGroup,
  ] = useState<ArticleCategoryGroupViewModel | null>(null);

  useEffect(() => {
    setCurrentGroup(categoryGroups[0]);
  }, []);

  return (
    <section className="tabs">
      <h2 className="mb-3">{heading}</h2>
      <ul className="tabs-list mb-4">
        {categoryGroups.map((g, i) => (
          <li key={i}>
            <button
              className={classNames("tab", {
                active: currentGroup == g,
              })}
              role="tab"
              aria-controls="newsCategoryList"
              onClick={() => setCurrentGroup(g)}
            >
              {g.heading}
            </button>
          </li>
        ))}
      </ul>

      <div
        id="newsCategoryList"
        className="tabs-tab-content mb-5"
        role="tabpanel"
      >
        <ul className="link-list link-list--bare-bones link-list--3-cols">
          {currentGroup &&
            currentGroup.categories.map((c, i) => (
              <li className="link-list--bare-bones__item" key={i}>
                {c.isActive && <a href={c.link.url}>{c.link.title}</a>}
                {!c.isActive && <span>{c.link.title}</span>}
              </li>
            ))}
        </ul>
      </div>
    </section>
  );
};
